import { PrivateRoute, OnlyDesktopRoute } from ".";
import { Outlet } from "react-router-dom";
import StudentInbox from "../pages/student/StudentInbox";
import StudentMaterial from "../pages/student/StudentMaterial";
import StduentProgress from "../pages/student/StudentProgress";
import StudentForum from "../pages/student/StudentForum";
import DocsUpload from "../pages/student/DocsUpload";
import MaterialDirectories from "../pages/common/MaterialDirectories";
import { Home } from "../components/Navigation";
import Header from "../components/Header";
import Announcement from "../pages/common/Announcement";
import AnnouncementDetail from "../pages/common/AnnouncementDetail";
import QnA from "../pages/common/QnA";
import FaQ from "../pages/common/FaQ";
import QnaDetail from "../pages/common/QnaDetail";
import QnaQuestion from "../pages/student/QnaQuestion";
import Report from "../pages/student/Report";
import RegisterTraining from "../pages/student/RegisterTraining";

const studentRoutes = [
  {
    path: "student",
    element: (
      <PrivateRoute role="student">
        <Header role="student" />
        <div className="content">
          <Outlet />
        </div>
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: <Home role="student" />,
      },
      {
        path: "progress",
        element: <StduentProgress />,
      },
      {
        path: "qna",
        children: [
          {
            path: "",
            element: <QnA role="student" />,
          },
          {
            path: "inbox",
            element: <StudentInbox />,
          },
          {
            path: "forum",
            element: <OnlyDesktopRoute />,
            children: [
              {
                path: "",
                element: <StudentForum />,
              },
              {
                path: ":id",
                element: <QnaDetail role="student" />,
              },
              {
                path: "question",
                element: <QnaQuestion />,
              },
            ],
          },
        ],
      },
      {
        path: "announcement",
        children: [
          {
            path: "",
            element: <Announcement role="student" />,
          },
          {
            path: ":id",
            element: <AnnouncementDetail />,
          },
        ],
      },
      {
        path: "material",
        element: <MaterialDirectories role="student" />,
        children: [
          {
            path: "",
            element: <h4>자료 종류를 선택해 주세요.</h4>,
          },
          {
            path: ":department/:directory",
            element: <StudentMaterial />,
          },
        ],
      },
      {
        path: "training",
        element: <OnlyDesktopRoute />,
        children: [{ path: "", element: <RegisterTraining /> }],
      },
      {
        path: "docs",
        element: <DocsUpload />,
      },
      {
        path: "report",
        element: <OnlyDesktopRoute />,
        children: [{ path: "", element: <Report /> }],
      },
      {
        path: "faq",
        element: <FaQ role="student" />,
      },
    ],
  },
];

export default studentRoutes;
